/**
 * 画布缩放计算（T01，纯函数，便于单测）。
 *
 * 规则：逻辑画布固定 390x844（与 `src/ui/measure.ts` 的 FRAME_WIDTH / FRAME_HEIGHT
 * 同源），只在窗口小于画布时整体等比缩小，**永不放大**。
 * 缩放只作用于视觉（`transform: scale()`），不改变任何内部布局坐标。
 */
import { FRAME_HEIGHT, FRAME_WIDTH } from '../ui';

/** 窗口尺寸 → 画布缩放系数（保留 4 位小数，避免无意义的浮点噪声）。 */
export function computeCanvasScale(viewportWidth: number, viewportHeight: number): number {
  if (!Number.isFinite(viewportWidth) || !Number.isFinite(viewportHeight)) return 1;
  if (viewportWidth <= 0 || viewportHeight <= 0) return 1;
  const scale = Math.min(1, viewportWidth / FRAME_WIDTH, viewportHeight / FRAME_HEIGHT);
  return Math.round(scale * 10000) / 10000;
}

/** 读当前窗口对应的画布缩放系数；非浏览器环境返回 1。 */
export function readViewportScale(): number {
  if (typeof window === 'undefined') return 1;
  return computeCanvasScale(window.innerWidth, window.innerHeight);
}